module.exports = __webpack_public_path__ + "static/media/loader.d2d1bb91.gif";